import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Card, Modal } from 'antd'
import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationOutlined,
} from '@ant-design/icons'
import '../../css/patient.scss'
import _ from 'lodash'
import moment from 'moment'
import util from '../../util/util'
import serviceInterface from '../../services/service.interface'
import PatientExercise from './patient.exercise'
import { useParams } from 'react-router'
import Play from '../../images/play.svg'
import PatientForm from './patient.form'
import PatientDevice from './patient.device'

const DayView = (props) => {
  const params = useParams()
  const [form, setForm] = useState(null)

  var handleFormSelect = ({ _id }) => setForm(_id)
  console.log('patientProps', props.patient)
  var renderForms = (forms) => {
    return forms
      ? forms.map((form, i) => {
          var future = moment(props.date)
            .startOf('day')
            .isSameOrAfter(moment().startOf('day'))
          return (
            <Row
              style={{ padding: '2px 2px' }}
              className='exerciseRow'
              align='middle'
            >
              <Col flex={'10px'}> &nbsp;</Col>
              <Col hidden={!form.meta?.complete} flex={'20px'}>
                {' '}
                <CheckCircleFilled className='checkIcon' />{' '}
              </Col>
              <Col hidden={form.meta?.complete} flex={'20px'}>
                {' '}
                <CloseCircleFilled
                  className={!future ? 'checkIcon red' : 'checkIcon grey'}
                />{' '}
              </Col>
              <Col
                flex={'auto'}
                className={form.meta?.complete ? 'name' : 'name incomplete'}
                onClick={() => form.meta?.complete && handleFormSelect(form)}
              >
                {form.meta?.name}
              </Col>
            </Row>
          )
        })
      : null
  }

  var renderEvents = (events) => {
    return events
      ? events.map((event) => {
          return (
            <Row className='eventRow'>
              <Col flex={'10px'}> &nbsp;</Col>
              <Col flex={'20px'}>
                <ExclamationOutlined className='closeIcon' />
              </Col>
              <Col flex='auto'>
                <Row className='eventHeader'>
                  {moment(event.date).format('MMMM DD')} -{event.title}
                </Row>
                <Row className='eventMessage' hidden={!event.message}>
                  {event.message}
                </Row>
              </Col>
            </Row>
          )
        })
      : null
  }

  var renderTitle = (date) => {
    return (
      <Row>
        <Col>
          {util.isSame(date, props.patient?.createdAt) && (
            <img height={21} width={21} src={Play} />
          )}
        </Col>
        <Col style={{ marginLeft: 'auto' }}>
          {moment(date).format('DD MMM')}
        </Col>
      </Row>
    )
  }

  var renderDays = () => {
    var days = new Array(props.days).join('.').split('.')
    return days.map((v, i) => {
      var date = moment(props.date).add('d', i).toDate()
      var exercises = serviceInterface
        .PatientService()
        .getExercises({
          date,
          schedules: props.patient?.exerciseSchedule?.exercisedateschedule,
        })
      var forms = serviceInterface
        .PatientService()
        .getFeed({
          date,
          schedules: props.patient?.feedbackSchedule?.feedbackdateschedule,
        })
      var events = serviceInterface
        .PatientService()
        .getEvent({ date, schedules: props.patient?.eventSchedule })
      var devices = serviceInterface
        .PatientService()
        .getEvent({
          date,
          schedules: props.patient?.deviceSchedule?.devicedateschedule,
        })
      // TracPatch measurement is the Progress Test (active ROM), recorded
      // outside the device timesheet — treat it as done when a Progress Test
      // was completed this day so it matches the calendar and the patient app.
      var romDone = serviceInterface
        .PatientService()
        .hasRomTestForDay(props.romTests, date)
      return (
        <>
          <Card className='dayCard' title={renderTitle(date)} bordered={false}>
            {!exercises && !forms && !events ? (
              <Row style={{ marginTop: 5, fontWeight: 500 }}>
                There are no specific activities, questionnaires or reminders
                assigned on this day.
              </Row>
            ) : (
              <>
                <Row hidden={!exercises}>
                  <Col style={{ width: '100%' }}>
                    <Row className='header'>&nbsp;ACTIVITIES</Row>
                    <Row className='container'>
                      <PatientExercise date={date} exercises={exercises} />
                    </Row>
                  </Col>
                </Row>
                <br hidden={!devices?.length > 0} />
                <Row hidden={!devices?.length > 0}>
                  <Col style={{ width: '100%' }}>
                    <Row className='header'>&nbsp;MEASUREMENTS</Row>
                    <Row className='container'>
                      <PatientDevice
                        date={date}
                        devices={devices[0]?.devices}
                        romDone={romDone}
                      />
                    </Row>
                  </Col>
                </Row>
                <br hidden={!exercises} />
                <Row hidden={!forms}>
                  <Col style={{ width: '100%' }}>
                    <Row className='header'>&nbsp;QUESTIONNAIRES</Row>
                    <Row className='container'>
                      <Col style={{ width: '100%' }}>{renderForms(forms)}</Col>
                    </Row>
                  </Col>
                </Row>
                <br hidden={!forms} />
                <Row hidden={!events}>
                  <Col style={{ width: '100%' }}>
                    <Row className='header'>&nbsp;REMINDERS</Row>
                    <Row className='container'>
                      <Col style={{ width: '100%' }}>
                        {renderEvents(events)}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            )}
          </Card>
          <Modal
            className={'formModal'}
            destroyOnClose={true}
            visible={form}
            footer={false}
            width={'70%'}
            onCancel={() => setForm(null)}
          >
            <PatientForm formid={form} />
          </Modal>
        </>
      )
    })
  }

  return (
    <Col className='dayViewContainer'>
      <Row justify='space-around'>{renderDays()}</Row>
    </Col>
  )
}

DayView.propTypes = {
  patient: PropTypes.object,
  date: PropTypes.object,
  romTests: PropTypes.array,
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
    romTests: state.patient.romTests,
  }
}

export default connect(mapStateToProps, null)(DayView)
